<template>
  <div class="rightSection">
    <slot name="quickFilter"></slot>
    <div class="rightSearch">
    <div class="searchBox fix-width__medium" style="width: 135px">
      <i
        class="fas fa-search color__silver"
      ></i>
      <el-input
        class="input-border__bottom input-border__radius__0"
        v-model="keyword_"
        size="medium"
        placeholder="Nhập từ khoá"
        @keydown.enter.exact.native="$emit('simpleSearch', keyword_)"
      />
    </div>
    <div
      class="advSearchToggler clickable"
      @click="$emit('search', keyword_)"
      v-if="!isDisableAdvanceSearch"
    >
      <i class="fas fa-cog"></i>
      <span class="no_wrap">Nâng cao</span>
    </div>
    </div>
    <slot
      name="advance"
      v-if="!isDisableAdvanceSearch"
    ></slot>
  </div>
</template>

<script>
  export default {
    name: 'search',
    props: ['keyword', "isDisableAdvanceSearch"],
    data() {
      return {
        keyword_: ''
      }
    },
    created() {
      this.keyword_ = this.keyword;
    },
    watch: {
      keyword(newValue) {
        this.keyword_ = newValue;
      }
    }
  }
</script>

<style scoped>
.rightSearch {
  display: flex;
}
.advSearchToggler {
  margin-top: 10px;
}
@media only screen and (min-width: 12in) and (max-width: 16in){
  .rightSearch {
    display: flex;
  }
  .advSearchToggler {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/search.vue